<template>
    <b-button v-b-tooltip.noninteractive.hover.top
              :class="[ButtonInsideClass , (Border ? '' : ' border-0')]"
              :disabled="
                    ((FeatureName !== undefined && FeatureName !== '') || (Action !== undefined && Action !== '') 
                            ? !$store.getters['CheckAction'](parameters?.Right ?? 'Read', FeatureName, Action)
                            : false) 
                    || Disabled"
              :title="Tooltip != undefined && Tooltip != '' ? Tooltip :
                                (parameters != undefined && parameters != null ? $t(parameters.Tooltip) : '')"
              :variant="Outline ? `outline-${Variant}` : Variant"
              class="btn-circle"
              v-on="$listeners">
        <b-icon :class="IconClass" :icon="parameters?.Icon ?? 'square'"/>
    </b-button>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import ButtonIcon from "../ButtonIcon";
import {ButtonActionEnum} from './ButtonIconSimpleParameters';
import ButtonParameters from "../../IButtonParameters";

@Component({
    i18n: ButtonIcon.MessageLocales()
})
export default class ButtonIconSimple extends ButtonIcon {
    /** Action du bouton */
    @Prop({default: () => ""})
    public ButtonAction!: string;

    private parameters: ButtonParameters;

    /** Alimentation des paramétrés suivant le type du bouton */
    created() {
        this.parameters = ButtonIcon.GetConstructorParametersButton(ButtonActionEnum, this.ButtonAction, this.Right);
        if (this.parameters == undefined && this.parameters != null)
            console.log('Le bouton ButtonIcon' + this.ButtonAction + ' n\'existe pas.')
    }

    constructor() {
        super();
    }
}
</script>

<style scoped>
</style>